import * as React from "react";
import { DemoErrorBoundary } from "@/components/landing/demos/DemoErrorBoundary";
import { DemoInteractionGuard } from "@/components/landing/demos/DemoInteractionGuard";
import { mockTodayActions } from "@/components/landing/demos/mockTodayData";
import { TodayView, type TodayViewAction } from "@/features/today/TodayView";

/**
 * Live Today UI preview for landing: TodayView + mock data + interaction guard.
 * Zero fetch, zero navigation; clicks disabled.
 * Wrapped in DemoErrorBoundary so crashes show fallback + console error.
 */
export function TodayPreviewDemo() {
  const actions: TodayViewAction[] = mockTodayActions;

  return (
    <div className="dark min-h-[320px]">
      <DemoErrorBoundary>
        <DemoInteractionGuard className="relative">
          <TodayView actions={actions} mode="demo" />
        </DemoInteractionGuard>
      </DemoErrorBoundary>
    </div>
  );
}
